// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePanelLeft as RawLucidePanelLeft } from "lucide-react";
export const LucidePanelLeft = /* @__PURE__ */ createIcon(RawLucidePanelLeft, "LucidePanelLeft", 2);
